import logdown from 'logdown';
import debug from 'debug';

const isDebugEnabled = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return process.env.NODE_ENV !== 'production' || !!searchParams.get('debug');
};

function setupLogging() {
  debug.enable(isDebugEnabled());
}

setupLogging();

export function getLogger(name = 'video') {
  const log = logdown(name, { prefixColor: `#EC0041` });
  log.state.isEnabled = isDebugEnabled();
  return log;
}

const log = getLogger();

/**
 * Returns log message
 *
 * @callback messageCallback
 * @returns {string} - message
 */

/**
 * Log when debug is true
 *
 * @param {messageCallback} cb - The callback that handles the message
 * @returns {void}
 */
export function lazyLog(cb, type = 'info') {
  if (!cb || !isDebugEnabled()) return;

  const msg = cb();
  log[type](msg);
}

export default log;
